import { createSelector } from 'reselect';

const selectGlobalStdCodes = (state: any) => state.globalStdCodes;


export const selectGlobalStdCodesCurrentItem = createSelector([selectGlobalStdCodes], (globalStdCodes) => globalStdCodes.current);

export const selectGlobalStdCodesListItems = createSelector([selectGlobalStdCodes], (globalStdCodes) => globalStdCodes.list);

export const selectGlobalStdCodesItemById = (itemId: any) =>
    createSelector(selectGlobalStdCodesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectGlobalStdCodesQueryItems = createSelector([selectGlobalStdCodes], (globalStdCodes) => globalStdCodes.query);

export const selectGlobalStdCodesCreatedItem = createSelector([selectGlobalStdCodes], (globalStdCodes) => globalStdCodes.create);

export const selectGlobalStdCodesUpdatedItem = createSelector([selectGlobalStdCodes], (globalStdCodes) => globalStdCodes.update);

export const selectGlobalStdCodesReadItem = createSelector([selectGlobalStdCodes], (globalStdCodes) => globalStdCodes.read);

export const selectGlobalStdCodesDeletedItem = createSelector([selectGlobalStdCodes], (globalStdCodes) => globalStdCodes.delete);

export const selectGlobalStdCodesSearchedItems = createSelector([selectGlobalStdCodes], (globalStdCodes) => globalStdCodes.search);

export const selectGlobalStdCodesItemsCount = createSelector([selectGlobalStdCodes], (globalStdCodes) => globalStdCodes.count);

export const selectGlobalStdCodesItemsFilter = createSelector([selectGlobalStdCodes], (globalStdCodes) => globalStdCodes.filter);